import { render, staticRenderFns } from "./sb-staking-farms.vue?vue&type=template&id=1c72fc77&scoped=true&"
import script from "./sb-staking-farms.vue?vue&type=script&lang=ts&"
export * from "./sb-staking-farms.vue?vue&type=script&lang=ts&"
import style0 from "./sb-staking-farms.vue?vue&type=style&index=0&id=1c72fc77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c72fc77",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
